import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
  standalone: true,
  imports: [RouterModule],
})
export class SpinnerComponent implements OnInit {
  role = false;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.authService.getCurrentUser().then((user) => {
      const roles: string = user.attributes['custom:roles'] ?? '';
      if (roles === 'Admin') {
        this.router.navigate(['/secure/administrator']);
      } else if (roles === 'Developer') {
        this.router.navigate(['/secure/developer']);
      } else if (roles.includes('Admin') && roles.includes('Developer')) {
        this.role = true;
      }
    });
  }
}
